/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export class TreeNode {
  public label: string;
  public breadCrumbLabel: string;
  public nodes: TreeNode[];
  public filteredNodes: TreeNode[];
  public icon: string;
  public enable = true;

  /**
   * can navigate on disable node
   */
  public canNavigateIfDisable = false;
  public id: string;

  /**
   * Is the node can receive drop ? (UI purpose only)
   */
  public canReceiveDrop = false;

  constructor(id: string, label: string, icon: string, nodes?: TreeNode[]) {
    this.id = id;
    this.label = label;
    this.breadCrumbLabel = label;
    this.icon = icon;
    this.nodes = nodes ? nodes : [];
    this.filteredNodes = this.nodes;
  }

  /**
   * Check if node has children
   */
  isLeaf(): boolean {
    return !this.nodes || this.nodes.length === 0;
  }

  filter(value: string): boolean {
    this.filteredNodes = [];
    if (this.label.toLowerCase().indexOf(value) === -1) {
      if (!this.nodes) {
        return false;
      }
      for (const node of this.nodes) {
        if (node.filter(value)) {
          this.filteredNodes.push(node);
        }
      }
      return this.filteredNodes.length > 0;
    } else {
      this.reset();
      return true;
    }
  }

  protected reset() {
    this.filteredNodes = this.nodes;
    for (const node of this.nodes) {
      node.reset();
    }
  }

  public toString(): string {
    return this.label;
  }
}
